import React from "react";
import MainAuth from "./MainAuth";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import RegisteredSuccessfuly from "src/components/authentication/RegisteredSuccessfuly";

const RegisteredSuccessfulyView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("auth_register_tab")}</title>
      </Helmet>
      <MainAuth>
        <RegisteredSuccessfuly />
      </MainAuth>
    </>
  );
};

export default RegisteredSuccessfulyView;
